module.exports = __webpack_public_path__ + "static/img/logo.cd3d5ce3.png";